import { TrendingUp, TrendingDown, ArrowRight } from 'lucide-react'
import type { AiqReportSummary } from '../../types/aiq-report'

interface Props {
  summary: AiqReportSummary
}

export function ScoreSummaryCards({ summary }: Props) {
  const isImproved = summary.improvement > 0
  const improvementColor = isImproved ? 'text-green-600' : summary.improvement < 0 ? 'text-red-600' : 'text-gray-600'
  const improvementBg = isImproved ? 'bg-green-50 border-green-200' : summary.improvement < 0 ? 'bg-red-50 border-red-200' : 'bg-gray-50 border-gray-200'

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      {/* Pre-AIQ Score */}
      <div className="p-6 bg-white rounded-xl border border-blue-200 shadow-2xs">
        <div className="flex items-center gap-2 mb-2">
          <div className="flex items-center justify-center w-8 h-8 bg-blue-100 rounded-lg">
            <span className="text-sm font-bold text-blue-600">Pre</span>
          </div>
          <span className="text-sm font-medium text-gray-500">Pre-AIQ</span>
        </div>
        <div className="text-3xl font-bold text-blue-600">{summary.preScore}<span className="text-lg text-gray-400">점</span></div>
        <p className="mt-1 text-sm text-gray-500">{summary.preCorrectCount}/{summary.totalQuestions}문제 정답</p>
      </div>

      {/* Post-AIQ Score */}
      <div className="p-6 bg-white rounded-xl border border-purple-200 shadow-2xs">
        <div className="flex items-center gap-2 mb-2">
          <div className="flex items-center justify-center w-8 h-8 bg-purple-100 rounded-lg">
            <span className="text-sm font-bold text-purple-600">Post</span>
          </div>
          <span className="text-sm font-medium text-gray-500">Post-AIQ</span>
        </div>
        <div className="text-3xl font-bold text-purple-600">{summary.postScore}<span className="text-lg text-gray-400">점</span></div>
        <p className="mt-1 text-sm text-gray-500">{summary.postCorrectCount}/{summary.totalQuestions}문제 정답</p>
      </div>

      {/* Improvement */}
      <div className={`p-6 rounded-xl border shadow-2xs ${improvementBg}`}>
        <div className="flex items-center gap-2 mb-2">
          <div className={`flex items-center justify-center w-8 h-8 rounded-lg ${isImproved ? 'bg-green-100' : 'bg-gray-100'}`}>
            {isImproved ? <TrendingUp className="w-4 h-4 text-green-600" /> : summary.improvement < 0 ? <TrendingDown className="w-4 h-4 text-red-600" /> : <ArrowRight className="w-4 h-4 text-gray-500" />}
          </div>
          <span className="text-sm font-medium text-gray-500">성장</span>
        </div>
        <div className={`text-3xl font-bold ${improvementColor}`}>
          {summary.improvement > 0 ? '+' : ''}{summary.improvement}<span className="text-lg text-gray-400">점</span>
        </div>
        <p className="mt-1 text-sm text-gray-500">
          {summary.improvementPercent > 0 ? '+' : ''}{summary.improvementPercent.toFixed(1)}% 변화
        </p>
      </div>
    </div>
  )
}
